module.exports = __webpack_public_path__ + "img/ea_fifa.96cd74ee.jpg";